module.exports = __webpack_public_path__ + "static/media/rev-left-img2.49039f62.png";